// i18n
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// 翻訳リソースを読み込む
import translationJP from "./jp/lang.json";
import translationEN from "./en/lang.json";

// i18nの初期化
i18n
  .use(initReactI18next) // react-i18nextを初期化
  .use(LanguageDetector) // 言語検出を初期化
  .init({
    // 翻訳リソース
    resources: {
      jp: {
        translation: translationJP,
      },
      en: {
        translation: translationEN,
      },
    },
    // フォールバック言語
    fallbackLng: "en",
    // デバッグモード
    debug: true,
    // リソースをHTMLでエスケープするかどうか
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
